import * as React from 'react';
const ChatSelectImageIcon = () => (
  <svg width={238} height={153} fill="none">
    <path
      d="M236.935 136.138c-6.811-7.052-16.376-11.439-26.973-11.439-4.201 0-8.239.689-12.009 1.96-4.086-5.947-10.947-9.853-18.721-9.853-2.764 0-5.412.493-7.86 1.394-7.855-15.868-24.248-26.78-43.195-26.78-24.517 0-44.752 18.261-47.758 41.883a42.566 42.566 0 0 0-10.661-1.343 42.367 42.367 0 0 0-28.811 11.235"
      stroke="#000"
      strokeWidth={0.563}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.51.857v131.949a37.106 37.106 0 0 0-9.583 2.904V.857h9.583Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.806 29.923 6.536 51.817l39.923 28.138L216.722 92l3.586-50.368-165.502-11.71Z"
      fill="#545454"
      stroke="#000"
      strokeWidth={0.563}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.812 23.574 2.538 45.47l44.688 28.471 165.498 11.71 3.586-50.369-165.498-11.71Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={0.563}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.19 28.178 13.725 46.263l36.507 23.46 158.012 11.18 2.958-41.546L53.19 28.177Z"
      fill="#E6F1FF"
      stroke="#000"
      strokeWidth={0.563}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m212.724 85.652 3.587-50.369 3.998 6.347L216.723 92l-3.999-6.347ZM46.46 79.953l.766-6.01-44.688-28.47 3.999 6.342L46.46 79.953Z"
      fill="#DBDBDB"
      stroke="#000"
      strokeWidth={0.563}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M171.475 152.595c-6.116-12.017-18.628-20.251-33.067-20.251-2.009 0-3.979.157-5.898.463a37.097 37.097 0 0 0-9.582 2.903 37.153 37.153 0 0 0-16.525 14.942M20.334 3.295 56.58 4.499M205.438 103.85l30.522 1.745"
      stroke="#000"
      strokeWidth={0.563}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ChatSelectImageIcon;
